import { Route, Router,Routes, useLocation } from 'react-router-dom';
import Footer from './Home_Page/components/Footer.jsx';
import Header from './Home_Page/components/Header.jsx';
import HomePage from './Home_Page/HomePage';
import Login from './Authentication_Page/Auth_components/Login.jsx';
import Shop from './Shop_Page/ShopPage';
// import ProductPage2 from './Product_Page/ProductPage';
import ProductPage from './Product_Page2/ProductPage';

import Account from './Account/Account.js';
import ReactGA from "react-ga4";
import { useEffect, useState } from 'react';
import CartPage from './Cart_Page/CartPage.js';
import CheckOut from './CheckOut/CheckOut.js';
import AboutUs from './AboutUs/AboutUs.js';
import ShipmentTracker from './TrackTest.js';
import { Toaster } from 'react-hot-toast';
import OrdersPage from './Orders/OrdersPage.js';
import OrderInfo from './Orders/Order.js';
import LearnBK from './LearnBK/LearnBK.js';
import Blog from './Blog/Blog.js';

import PaymentStatus from './PaymentStatus/PaymentStatus.js';
import Recipes from './Product_Page2/Recipes/Recipes.js';
import WhatsappFloatButton from './Home_Page/WhatsappFloatButton.jsx';
import ShippingPolicy from './Policy/ShippingPolicy.js';
import PrivacyPolicy from './Policy/PrivacyPolicy.js'
import ReturnAndRefundPolicy from './Policy/RefundExchangePolicy.js'
import HoneyTimelineShop from './Shop_Page/HoneyTimelineShop.jsx';
import GreatHoneyProductPage from './test.js';
import Analytics from './Analytics.js';

// import Cart from './Cart_Page/Cart_components/Cart.jsx';




const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};


// import { Routes } from 'react-router-dom';
function App() {


const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isProductPage = location.pathname.startsWith("/product");



  // Hide footer on checkout page
  const hideFooterPages = ["/checkout","/cart"];



  usePageTracking();
  return (
    <div className="App">
            <Toaster />
            

      <Header />
      {/* {!hideFooterPages.includes(location.pathname) &&  <WhatsappFloatButton/>
      } */}
{!hideFooterPages.includes(location.pathname) &&
        !(isProductPage && isMobile) && (
          <WhatsappFloatButton />
        )}
            <Analytics/>

    <Routes>
      
      <Route path="/" element={ <HomePage/>} />
      <Route path="/login" element={ <Login/>} />
      <Route path="/payment-stat" element={ <PaymentStatus/>} />

      <Route path="/learn-beekeeping" element={ <LearnBK/>} />
      <Route path="/shop" element={ <Shop/>} />
            <Route path="/shop-test" element={ <HoneyTimelineShop/>} />

      <Route path="/privacy-policy" element={ <PrivacyPolicy/>} />
      <Route path="/rar-policy" element={ <ReturnAndRefundPolicy/>} />
      <Route path="/shipping-policy" element={ <ShippingPolicy/>} />
<Route path="/test1" element={<GreatHoneyProductPage/>}/>
      <Route path="/blog" element={ <Blog/>} />

      <Route path="/about" element={ <AboutUs/>} />
      <Route path="/orders" element={ <OrdersPage/>} />
      <Route path="/recipes" element={ <Recipes/>} />

      
      <Route path="/checkout" element={ <CheckOut/>} />
      <Route path="/cart" element={ <CartPage/>} />
      <Route path="/product/:id" element={ <ProductPage/>} />
      <Route path="/order" element={ <OrderInfo/>} />

      <Route path="/account" element={<Account />} />






    </Routes>

    {!hideFooterPages.includes(location.pathname) && <Footer />}

      
    </div>
  );
}

export default App;



